var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { Draggable } from '@hello-pangea/dnd';
import { getLight, getDark } from '../utils';
import { BOX, wcagId } from './constants';
export var useStyles = makeStyles(function (theme) {
  var _ref;
  return _ref = {
    containerButton: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: theme.spacing(1),
      borderRadius: theme.spacing(0.5),
      userSelect: 'none'
    },
    styledItemContainer: {
      cursor: 'grab',
      minHeight: 32,
      borderRadius: theme.spacing(0.5),
      alignItems: 'center',
      paddingTop: theme.spacing(0.25),
      paddingBottom: theme.spacing(0.25),
      margin: theme.spacing(0.25),
      opacity: 1,
      flexFlow: 'wrap'
    }
  }, _ref[BOX.sections + 'Item'] = {
    color: theme.palette.getContrastText(getDark(theme) || theme.palette.secondary.dark),
    backgroundColor: getDark(theme) || theme.palette.secondary.dark
  }, _ref[BOX.rows + 'Item'] = {
    color: theme.palette.getContrastText(getLight(theme) || theme.palette.secondary.light),
    backgroundColor: getLight(theme) || theme.palette.secondary.light
  }, _ref[BOX.header + 'Item'] = {
    color: theme.palette.getContrastText(theme.palette.primary.main),
    backgroundColor: theme.palette.primary.main
  }, _ref.cantMove = {
    cursor: 'no-drop'
  }, _ref.text = {
    fontStyle: 'italic',
    fontSize: theme.typography.fontSize - 2,
    fontWeight: theme.typography.fontWeightBold
  }, _ref.itemButton = {
    paddingTop: theme.spacing(0.25),
    paddingBottom: theme.spacing(0.25),
    paddingRight: 0
  }, _ref.select = {
    padding: theme.spacing(0.5, 4, 0.5, 2),
    backgroundColor: theme.palette.common.white,
    '&:focus': {
      backgroundColor: theme.palette.common.white
    }
  }, _ref.spaceButton = {
    margin: theme.spacing(0, 1, 0, 0)
  }, _ref;
});
var DnDItem = function DnDItem(_ref2) {
  var item = _ref2.item,
    index = _ref2.index,
    itemRenderer = _ref2.itemRenderer,
    dropZoneLabel = _ref2.dropZoneLabel,
    itemButtonProps = _ref2.itemButtonProps,
    canDrag = _ref2.canDrag;
  var classes = useStyles();
  var selectItem = R.prop(item.id)(itemButtonProps);
  return React.createElement(Draggable, {
    key: item.id,
    draggableId: item.id,
    index: index,
    isDragDisabled: R.not(canDrag)
  }, function (provided) {
    var _cx, _cx2;
    return React.createElement('div', _extends({
      'data-testid': 'draggable-' + item.id,
      ref: provided.innerRef
    }, provided.draggableProps, provided.dragHandleProps, {
      className: cx(classes.styledItemContainer, classes.containerButton, [R.prop(dropZoneLabel + 'Item')(classes)], (_cx = {}, _cx[classes.cantMove] = R.not(canDrag), _cx)),
      'aria-label': itemRenderer(item),
      'aria-describedby': wcagId
    }), React.createElement(Fragment, null, React.createElement(Typography, {
      variant: 'body2',
      className: cx(classes.text, (_cx2 = {}, _cx2[classes.spaceButton] = selectItem, _cx2))
    }, itemRenderer(item)), selectItem && React.createElement(Select, {
      id: item.id,
      value: selectItem.value,
      onChange: function onChange(e) {
        return selectItem.onChange(e.target.value);
      },
      classes: {
        root: classes.select
      },
      variant: 'outlined'
    }, R.map(function (v) {
      return React.createElement(MenuItem, {
        key: v,
        value: v
      }, v);
    })(selectItem.options))));
  });
};
DnDItem.propTypes = process.env.NODE_ENV !== "production" ? {
  item: PropTypes.object,
  index: PropTypes.number,
  itemRenderer: PropTypes.func,
  dropZoneLabel: PropTypes.string,
  onChangeLayout: PropTypes.func,
  itemButtonProps: PropTypes.object,
  handleChangeBox: PropTypes.func,
  canDrag: PropTypes.bool,
  dropZoneIndex: PropTypes.number
} : {};
export default DnDItem;